export function isQueryKey(value) {
    return typeof value === 'function';
}
// The parseQuery Args functions helps normalize the arguments into the correct form.
// Whatever the parameters are, they are normalized into the correct form.
export function parseQueryArgs(arg1, arg2, arg3) {
    if (!isQueryKey(arg1)) {
        const { queryKey: solidKey, ...opts } = arg1;
        if (solidKey) {
            return {
                ...opts,
                queryKey: solidKey(),
            };
        }
        return arg1;
    }
    if (typeof arg2 === 'function') {
        return { ...arg3, queryKey: arg1(), queryFn: arg2 };
    }
    return { ...arg2, queryKey: arg1() };
}
export function parseFilterArgs(arg1, arg2, arg3) {
    return (isQueryKey(arg1)
        ? [{ ...arg2, queryKey: arg1() }, arg3]
        : [{ ...arg1, queryKey: arg1?.queryKey?.() }, arg2]);
}
export function shouldThrowError(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') {
        return _useErrorBoundary(...params);
    }
    return !!_useErrorBoundary;
}
export function sleep(timeout) {
    return new Promise((resolve) => {
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */
export function scheduleMicrotask(callback) {
    sleep(0).then(callback);
}
